import swal from 'sweetalert';
import { sfRequestSync, sfRequest, encryptQuery } from '../utils/common';

import {
    q_POSTAL_CODE_RECORD,
    q_SCHOLL_LIST,
    q_APPLYING_TO,
    q_RECORD_TYPE,
} from './query';
import { fetchQueryData } from '../utils/sf-request';

export const spmfcloudFunctionUrl = __DEV__ ? process.env.SANDBOX_API : 'https://portal.spmf.org.sg/api';
// export const spmfcloudFunctionUrl = __DEV__ ? 'https://spmf.interaktiv.sg:2018' : 'https://spmf.interaktiv.sg:2018';
// here replace the production url with aws url
export const spmfcloudPostalFunctionUrl = 'https://portal.spmf.org.sg/postal-code/';
const SF_VERSION = 'v20.0';

export function getSalesforceToken(callback) {
    return async (dispatch, getState) => {
        const { siteToken } = getState().user;
        const url = `${spmfcloudFunctionUrl}/salesforce-token`;
        await fetch(url, {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                // Authorization: `Bearer ${token}`,
                Accepted: 'application/json',
                'hash-token': siteToken.hash,
            },
            mode: 'cors',
            cache: 'default',
        }).then(response => response.json())
            .then((responseData) => {
                // localStorage.setItem('tokensf', responseData.accessToken);
                if (typeof callback === 'function') callback();
                dispatch({
                    type: 'SALESFORCE_TOKEN',
                    payload: responseData,
                });
            });
    };
}

export function getLatestApplicationDetail(id) {
    return async (dispatch, getState) => {
        const { siteToken } = getState().user;
        const json = await fetch(`${spmfcloudFunctionUrl}/salesforce/application/latest/${id}`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: {
                'hash-token': siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(response => response.json())
            .then((responseData) => {
                dispatch({
                    type: 'APPLICATION_INFO',
                    payload: responseData,
                });
            })
            .catch(err => console.log(err));
        return json;
    };
}

export function checkEmail(email) {
    const query = `SELECT Id FROM Contact WHERE Portal_Login_Name__c = '${email}'`;
    const { user } = this.props;
    return fetchQueryData(query, user.siteToken.hash, user.key);
}

export function getBeneficieryList(id, token, publicKey) {
    return async (dispatch) => {
        const query = `Select Id,Monthly_Gross_Income__c,Employment_Status__c, Contact_Name__r.Active__c, Current_School__c	,Contact_Name__r.Name, Race__c,
        Application__r.Applicant_Name__c,Contact_Name__r.Last_Payment_Date__c, Application_Status__c,
        Full_Name__c, Gender__c, ID_type__c, Nationality__c, ID_Number__c, Date_of_Birth__c,Other_Race__c,Current_Level__c,Stream__c,Applying_to__c,Email_Address__c,Relationship_to_Applicant__c FROM Person__c WHERE Contact_Name__c <> null and Application__r.Related_Account__c = '${id}'  and RecordType.Name = 'Beneficiary'`;
        const json = await fetchQueryData(query, token, publicKey).then((responseData) => {
            dispatch({
                type: 'BENEFICIERY_INFO',
                payload: responseData,
            });
        });
        return json;
    };
}

export function getHouseholdMembersList(id, token, publicKey) {
    return async (dispatch) => {
        const query = `Select Id, Application__c,Name,Full_Name__c,ID_Type__c,ID_Number__c,
            Date_of_Birth__c,Gender__c,Race__c	,Other_Race__c,Nationality__c,Other_Nationality__c,
            Relationship_to_Applicant__c,Monthly_Gross_Income__c,Employment_Status__c,Occupation__c,
            Company__c,Application__r.Other_Source_of_Income__c,Application__r.Other_Source_of_Income_Amount__c 
            from Person__c
            Where RecordType.Name <> 'Beneficiary' AND Application__c = '${id}' ORDER BY Id ASC`;
        const json = await fetchQueryData(query, token, publicKey).then((responseData) => {
            dispatch({
                type: 'HOUSEHOLD_MEMBERS_INFO',
                payload: responseData,
            });
        });
        return json;
    };
}

export function getPostalCodeRecord(callback) {
    return async (dispatch, getState) => {
        let fullUrl = '';
        const salesforceToken = getState().salesforce.token;
        if (salesforceToken !== null) {
            fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/query/?q=${encodeURIComponent(q_POSTAL_CODE_RECORD)}`;
        }
        const fetchConfig = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${salesforceToken.accessToken}`,
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
            timeout: 5000,
        };
        const json = await fetch(fullUrl, fetchConfig).then(response => response.json()).catch((err) => {
            dispatch({ type: 'TOGGLE_LOADING' });
            setTimeout(() => null, 0);
            swal('Error occured', `Connection to salesforce currently can't be established, ${err.message}.`);
        }).then((responseData) => {
            dispatch({ type: 'TOGGLE_LOADING' });
            if (responseData.length > 0) {
                if (responseData[0].errorCode) {
                    swal('Error occured', `An Error occured "${responseData[0].errorCode} - ${responseData[0].message} - ${sobject}".`);
                } else {
                    dispatch({
                        payload: responseData,
                        type: 'POSTAL_CODE_RECORD',
                    });
                }
            } else {
                dispatch({
                    payload: responseData,
                    type: 'POSTAL_CODE_RECORD',
                });
            }
        });
        return json;
    };
}

export function getSchoolList(callback) {
    return async (dispatch, getState) => {
        let fullUrl = '';
        const salesforceToken = getState().salesforce.token;
        if (salesforceToken !== null) {
            fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/query/?q=${encodeURIComponent(q_SCHOLL_LIST)}`;
        }
        const fetchConfig = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${salesforceToken.accessToken}`,
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
            timeout: 5000,
        };
        await fetch(fullUrl, fetchConfig).then(response => response.json()).catch((err) => {
            dispatch({ type: 'TOGGLE_LOADING' });
            setTimeout(() => null, 0);
            swal('Error occured', `Connection to salesforce currently can't be established, ${err.message}.`);
        }).then((responseData) => {
            dispatch({ type: 'TOGGLE_LOADING' });
            if (responseData.length > 0) {
                if (responseData[0].errorCode) {
                    swal('Error occured', `An Error occured "${responseData[0].errorCode} - ${responseData[0].message} - Account".`);
                } else {
                    dispatch({
                        payload: responseData,
                        type: 'SCHOOL_LIST',
                    });
                }
            } else {
                dispatch({
                    payload: responseData,
                    type: 'SCHOOL_LIST',
                });
            }
        });
    };
}

export function getApplyingToList(callback) {
    return async (dispatch, getState) => {
        let fullUrl = '';
        const salesforceToken = getState().salesforce.token;
        if (salesforceToken !== null) {
            fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/query/?q=${encodeURIComponent(q_APPLYING_TO)}`;
        }
        const fetchConfig = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${salesforceToken.accessToken}`,
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
            timeout: 5000,
        };
        await fetch(fullUrl, fetchConfig).then(response => response.json()).catch((err) => {
            dispatch({ type: 'TOGGLE_LOADING' });
            setTimeout(() => null, 0);
            swal('Error occured', `Connection to salesforce currently can't be established, ${err.message}.`);
        }).then((responseData) => {
            dispatch({ type: 'TOGGLE_LOADING' });
            if (responseData.length > 0) {
                if (responseData[0].errorCode) {
                    swal('Error occured', `An Error occured "${responseData[0].errorCode} - ${responseData[0].message} - ${sobject}".`);
                } else {
                    dispatch({
                        payload: responseData,
                        type: 'APPLYING_TO_LIST',
                    });
                }
            } else {
                dispatch({
                    payload: responseData,
                    type: 'APPLYING_TO_LIST',
                });
            }
        });
    };
}

export const getRecordType = () => (
    (dispatch, getState) => {
        // if (getState().currentUser === null) return;
        const salesforceToken = getState().salesforce.token;
        // const recordType = getState().salesforce.recordType;
        sfRequest(null, {
            method: 'GET',
            url: salesforceToken.instanceUrl,
            id: 'describe',
            accessToken: salesforceToken.accessToken,
            query: q_RECORD_TYPE,
        }, dispatch, 'RECORD_TYPE');
    }
);

export function getApplicationField(salesforceToken) {
    const fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobjects/Application__c/describe`;
    const fetchConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${salesforceToken.accessToken}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        },
        timeout: 5000,
    };
    return fetch(fullUrl, fetchConfig).then(response => response.json());
}

export function getPersonField(salesforceToken) {
    const fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobjects/Person__c/describe`;
    const fetchConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${salesforceToken.accessToken}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        },
        timeout: 5000,
    };
    return fetch(fullUrl, fetchConfig).then(response => response.json());
}

export const createApplication = data => (
    (dispatch, getState) => {
        const salesforceToken = getState().salesforce.token;
        sfRequest('Application__c', {
            method: 'POST',
            url: salesforceToken.instanceUrl,
            id: 'describe',
            accessToken: salesforceToken.accessToken,
            bodyParams: data,
        }, ({ type, payload }) => {
            if (type === 'CREATE_APPLICATION') {
                console.log(payload);
                dispatch({ type, payload });
            } else {
                console.log(payload);
                dispatch({ type, payload });
            }
        }, 'CREATE_APPLICATION');
    }
);

export function retrieveObject(sobject, id, salesforceToken, query, key) {
    let fullUrl = '';
    if (sobject != null) {
        fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobject/${sobject}`;
    } else {
        fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/query/?q=${encodeURIComponent(query)}${typeof key === 'object' ? `(${encodeURIComponent(key.toString())})` : `'${key}'`}`;
    }

    const fetchConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${salesforceToken.accessToken}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        },
        timeout: 5000,
    };
    return fetch(fullUrl, fetchConfig).then(response => response.json());
}

export function getAttachment(urlBody, salesforceToken) {
    const fullUrl = `${salesforceToken.instanceUrl}${urlBody}`;
    const fetchConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${salesforceToken.accessToken}`,
            'Cache-Control': 'no-cache',
        },
        timeout: 5000,
    };
    return fetch(fullUrl, fetchConfig).then(async (response) => {
        const blob = await response.blob();
        if (response.ok) {
            const base64Promise = new Promise((resolve, reject) => {
                try {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        resolve(reader.result.split(',')[1]);
                    }
                } catch (err) {
                    reject(err);
                }
            });

            return base64Promise;
        }
        throw new Error('Error happens when retrieving attachment body');
    });
}

export function saveObject(sobjects, data, salesforceToken) {
    const fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobjects/${sobjects}/`;
    const fetchConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${salesforceToken.accessToken}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        },
        body: JSON.stringify(data),
        timeout: 5000,
    };
    return fetch(fullUrl, fetchConfig).then(async (response) => {
        const json = await response.json();
        if (response.status >= 200 && response.status < 300) {
            return json;
        }
        throw new Error(JSON.stringify(json));
    });
}

export async function updateObject(sobjects, id, data, salesforceToken, isUploadApi = false) {
    const fullUrl = `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobjects/${sobjects}/${id}`;
    const fetchConfig = {
        method: 'PATCH',
        headers: {
            Authorization: `Bearer ${salesforceToken.accessToken}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        },
        body: JSON.stringify(data),
        timeout: 15000,
    };
    const returnTypeData = await fetch(fullUrl, fetchConfig);

    if (!returnTypeData.ok) {
        let errorMsg = '';
        if (isUploadApi) {
            errorMsg = 'Error when uploading file';
        } else {
            const json = await returnTypeData.json();
            errorMsg = json.message;
        }
        throw new Error(errorMsg);
    }

    return returnTypeData;
}



//////////////////
// WEBPACK FOOTER
// ./src/actions/salesforces.js
// module id = 10
// module chunks = 0